var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.692 7.95H3.556c-.307 0-.556.224-.556.5s.249.5.556.5h8.136l-4.096 4.096a.5.5 0 1 0 .707.707l4.243-4.243c.258-.258.402-.587.433-.924a.45.45 0 0 0 0-.273 1.5 1.5 0 0 0-.433-.924L8.303 3.146a.5.5 0 1 0-.707.708z"
  })));
};
export default SvgArrowRight;